import React, { useState } from "react";
// import './SharingComponent.css';
import {
    IoCloseSharp,
    IoLinkOutline,
    IoMailOutline,
    IoSettingsOutline,
} from "react-icons/io5";
import { toAbsoluteUrl } from "../../../_helpers";
import DiamondTypeTag from "../DiamondTypeTag";
import CertificateLink from "../../CertificateLink";
import { PiFileTxt, PiNotePencilLight } from "react-icons/pi";
import { MdOutlineContentCopy } from "react-icons/md";
import "react-quill/dist/quill.snow.css";
import RichTextModal from "./RichTextModal";
import axios from "axios";
import { NODE_API_URL } from "../../../../env_config";
import Cookies from "js-cookie";
import { FaWhatsapp } from "react-icons/fa";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import moment from "moment";
import ShareDetailCardSkeleton from "./ShareDetailCardSkeleton";

const SharingComponent = ({
    data,
    close,
    setOpenShareSetting,
    setNotes,
    setPhone,
    phone,
    finalPayload,
    userinfo,
    selectedValue,
    startDate,
    password,loader,metaData
}) => {
    const [focused, setFocused] = useState(false);
    const [openEditor, setOpenEditor] = useState(false);
    const [editorData, setEditorData] = useState("");
    const [contactInput, setContactInput] = useState("");
    const [contactType,] = useState(null);
    const [contactError, setContactError] = useState("");
    const [editorValue, setEditorValue] = useState("");
    const [shareMode, setShareMode] = useState("email"); // email | whatsapp
    const [successMsg, setSuccessMsg] = useState("");

    const showSuccess = (msg) => {
        setSuccessMsg(msg);

        setTimeout(() => {
            setSuccessMsg("");
        }, 5000);
    };

    const countryNameToIso = (name) => {
    const map = {
        India: "in",
        "United States": "us",
        "Hong Kong": "hk",
        UAE: "ae",
        China: "cn",
        Belgium: "be",
    };

    return map[name] || "in";
    };

    const isValidEmail = (email) => {
        const regex =
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const isValidPhone = (phone) => {
        const cleaned = phone.replace(/\D/g, "");

        // International format: 10–15 digits
        return cleaned.length >= 10 && cleaned.length <= 15;
    };

    const formatPhoneInternational = (phone) => {
        let cleaned = phone.replace(/\D/g, "");

        // If user entered 10 digit Indian number → auto add 91
        if (cleaned.length === 10) {
            cleaned = "91" + cleaned;
        }

        return cleaned;
    };

    const generateDiamondText = (data) => {
        return (
            `
        <p><strong>${data?.diamondType  === "N" || data?.diamondType === "F" ? "Natural" : "Lab Grown"}</strong> Diamond Details </p>
        <p>Stone ID: <strong>${data?.stockID || "-"}</strong></p>
        <p>Shape: <strong>${data?.shape || "-"}</strong></p>
        <p>Carat: <strong>${data?.carat ? data.carat.toFixed(2) : "-"}</strong></p>
        <p>Clarity: <strong>${data?.clarity || "-"}</strong></p>
        <p>Color: <strong>${data?.color ==="fancy" ? `${data?.fancy_intensity} ${data?.fancy_overtone} ${data?.fancy_color}` : data?.color || ""}</strong></p>
        <p>Cut: <strong>${data?.cut || "-"}</strong></p>
        <p>Pol: <strong>${data?.polish || "-"}</strong></p>
        <p>Symm: <strong>${data?.symmetry || "-"}</strong></p>
        <p>Fluor: <strong>${data?.fluorescence || ""}</strong></p>
        <p>Shade: <strong>${data?.shade || "-"}</strong></p>
        <p>Milky: <strong>${data?.milky || "-"}</strong></p>
        <p>Eye Clean: <strong>${data?.eyeClean || "-"}</strong></p>
        <p>Lab: <strong>${data?.lab || "-"}</strong></p>
        ${data?.showsharecertificate ? `<p>Certificate No.: <strong>${data?.certificate || "-"}</strong></p>` : "" }
        <p>Meas: <strong>${
            data?.length && data?.width && data?.height
                ? `${data.length}${data?.shape?.toLowerCase() === "round" ? "*" : "-"}${data.width}*${data.height}`
                : "-"
            }</strong></p>
        ${data?.tablePercent ? `<p>Depth: <strong>${data?.tablePercent || "-"}</strong></p>` : ""}
        ${data?.depthPercent ? `<p>Table: <strong>${data?.depthPercent || "-"}</strong></p>` : "" }
        ${(data?.ratio || data?.ratio !== "-") ? `<p>Ratio: <strong>${data?.ratio || "-"}</strong></p>` : ""}
        ${data?.origin && data?.origin !== 'Other' && data?.origin !== 'NONE' && data?.origin !== 'NON'  ? `<p>Origin: <strong>${data?.origin || "-"}</strong></p>` : ""}
        ${data?.brand && data?.brand !== 'Other'? `<p>Brand: <strong>${data?.brand || "-"}</strong></p>` : ""}
        ${data?.treatment && data?.treatment !== 'NONE' && data?.treatment !== 'NON' ? `<p>Treatment: <strong>${data?.treatment || "-"}</strong></p>` : ""}
        ${data?.image ? `<p>Image: <a href="${data?.image}" target="_blank" rel="noreferrer" >${data?.image || "-"}</a></p>` : "" }
        ${data?.video ? `<p>Video: <a href="${data?.video}" target="_blank" rel="noreferrer" >${data?.video || "-"}</a></p>` : "" }
        ${data?.showsharecertificate ? `<p>Certificate : <a href="${data?.certificate_link}" target="_blank" rel="noreferrer" >${data?.certificate_link || "-"}</a></p>` : "" }
        `.trim());
    };



    const htmlToWhatsapp = (html) => {
    return html
        .replace(/\n/g, "") 
        .replace(/\s+/g, " ") 
        .replace(/<strong>(.*?)<\/strong>/gi, "*$1*")
        .replace(/<b>(.*?)<\/b>/gi, "*$1*")
        .replace(/<em>(.*?)<\/em>/gi, "_$1_")
        .replace(/<i>(.*?)<\/i>/gi, "_$1_")
        .replace(/<\/p>/gi, "\n\n")
        .replace(/<p[^>]*>/gi, "")
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<a[^>]*href="([^"]*)"[^>]*>(.*?)<\/a>/gi, "$2: $1")
        .replace(/<[^>]+>/g, "")
        .replace(/\n{3,}/g, "\n\n")
        .trim();
    };

    const handleSmartSend = async () => {
    if (!contactInput) {
        setContactError("Required field");
        return;
    }

    if (shareMode === "email") {
    if (!isValidEmail(contactInput)) {
        setContactError("Invalid email address");
        return;
    }

    try {
        const res = await axios.post(
        `${NODE_API_URL}/INTL/share-product`,
        {
            ...finalPayload,
            share_type: "email",
            share_through: "email",
            email: contactInput,
        },
        {
            headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
        }
        );

        showSuccess("Email sent successfully");
        setContactInput("");
        return; 
    } catch (e) {
        setContactError("Failed to send email");
        return; 
    }
    }

    // WhatsApp flow
    if (!isValidPhone(contactInput)) {
        setContactError("Invalid phone number");
        return;
    }

    const formattedPhone = contactInput.replace(/\D/g, "");

     const result = await axios.post(
        `${NODE_API_URL}/INTL/share-product`,
        {
            ...finalPayload,
            share_type: "link",
            share_through: "whatsapp",
            mobile_no: formattedPhone,
        },
        {
            headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
        }
    );

    if (result?.data?.success){
           let link = `https://pro.dia360.cloud/share/${result?.data?.share_token}?title=${encodeURIComponent(metaData?.title)}&shape=${encodeURIComponent(metaData?.shape)}`
           let text = `
            <p>Hi,</p>
            <p><strong>${userinfo?.cname}</strong> is sharing a link for
            <strong>${data?.diamondType === "N" || data?.diamondType === "F" ? "Natural" : "Lab Grown"}</strong> Diamond -
            <strong>${data?.shape} ${data?.carat ? `${data?.carat.toFixed(2)}Ct` : ""} 
                ${data?.color === "fancy"
                ? `${data?.fancy_intensity} ${data?.fancy_overtone} ${data?.fancy_color}`
                : data?.color || ""} ${data?.clarity}</strong></p>
            <p>Link: ${link}</p>
            `;
            
            const whatsappText = htmlToWhatsapp(text);
            window.open(
                `https://wa.me/${formattedPhone}?text=${encodeURIComponent(whatsappText)}`
            );
            showSuccess("Link shared on whatsApp successfully");
        }
    };


    function numberWithCommas(x) {
        if (x) {
            return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
            return "0.00";
        }
    }

    const handleWhatsAppShare = async () => {
        // if (!contactInput) {
        //     alert("Please enter WhatsApp number with country code.");
        //     return;
        // }
         if (!contactInput) {
            setContactError("Required field");
            return;
        }
        await axios.post(
            `${NODE_API_URL}/INTL/share-product`,
            {
                ...finalPayload,
                share_type: "whatsapp",
                share_through: "whatsapp",
                mobile_no: contactInput,
            },
            {
                headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
                },
            }
        );
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = editorData; // or editorValue if from modal

        // let text = "";
        // tempDiv.querySelectorAll("p").forEach((p) => {
        //     text += p.innerText + "\n\n";
        // });

        // const encodedText = encodeURIComponent(text.trim());
        const whatsappText = htmlToWhatsapp(editorValue);
        const url = `https://wa.me/${contactInput}?text=${encodeURIComponent(whatsappText)}`;

        window.open(url, "_blank");
        showSuccess("Shared via WhatsApp");
    };

    const handleCopy = async () => {

        try {
            const res =  await axios.post(
            `${NODE_API_URL}/INTL/share-product`,
            {
                ...finalPayload,
                share_type: "link",
                share_through: "link",
                // phone: formattedPhone,
            },
            {
                headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
                },
            }
        );

        if (res?.data?.success){
            let link = `https://pro.dia360.cloud/share/${res?.data?.share_token}?title=${metaData?.title}&shape=${metaData?.shape}`
            navigator.clipboard.writeText(link);
            showSuccess("Link copied to clipboard!");
        }

        } catch {

        }
        // alert("Link copied to clipboard!");
    };
    return (
        <>
            <div className="d-flex justify-content-between mb-3">
                <span className=" font-size-h5 font-weight-bold">Share</span>
                <div>
                    <button
                        className="btn btn-sm btn-clear btn-hover-bg-light px-1 py-1"
                        onClick={() => setOpenShareSetting(true)}
                    >
                        <IoSettingsOutline className=" font-size-h4 text-primary" />
                    </button>
                    <button
                        className="btn btn-sm btn-clear btn-hover-bg-light px-1 py-1"
                        onClick={close}
                    >
                        <IoCloseSharp className=" font-size-h4 text-muted" />
                    </button>
                </div>
            </div>
            <div className="row">
                {loader ? <div className="col-12"><ShareDetailCardSkeleton /></div> :
                    <>
                        <div className="col-12 d-flex mb-4">
                            <div>
                                {data?.image ? (
                                    <img
                                        className="img-fluid"
                                        alt={data?.shape}
                                        src={data?.image}
                                        width="90px"
                                        onError={(e) => {
                                            e.currentTarget.src = toAbsoluteUrl(
                                                `/media/shape/${
                                                    data?.shape
                                                        ? data?.shape.toLowerCase()
                                                        : ""
                                                }-no.png`,
                                            );
                                        }}
                                    />
                                ) : (
                                    <img
                                        className="img-fluid"
                                        alt={data?.shape}
                                        src={toAbsoluteUrl(
                                            `/media/shape/${
                                                data?.shape
                                                    ? data?.shape.toLowerCase()
                                                    : ""
                                            }-no.png`,
                                        )}
                                        onError={(e) => {
                                            e.currentTarget.src = toAbsoluteUrl(
                                                `/media/shape/noimage.jpg`,
                                            );
                                        }}
                                        width="90px"
                                        style={{ backgroundColor: "#f4f4f4" }}
                                    />
                                )}
                            </div>
                            <div className="ml-4">
                                <div
                                    className={`mb-1 ${
                                        data?.diamondType === "N" ? "natTab" : "labTab"
                                    }`}
                                >
                                    <DiamondTypeTag
                                        diamondTypeTagColor={data?.diamondTypeTagColor}
                                        diamondTypeTag={data?.diamondTypeTag}
                                    />
                                    <span className={`text-primary small`}>
                                        {data?.diamondType === "N" ||
                                        data?.diamondType === "W"
                                            ? "N"
                                            : "L"}
                                        -{data?.stockID}
                                    </span>
                                    {data?.showsharecertificate && (
                                        <CertificateLink
                                            Certificate_link={data?.certificate_link}
                                            lab={data?.lab}
                                            certificate={data?.certificate}
                                            className={`mx-2 small`}
                                        />
                                    )}
                                </div>
                                <span className="text-dark font-weight-bold d-block">
                                    {data?.shape} {data?.carat ? data?.carat.toFixed(2) : null} {data?.color}{" "}
                                    {data?.clarity} {data?.cut} {data?.polish}{" "}
                                    {data?.symmetry} {data?.fluorescence}
                                </span>
                                {data?.showshareprice && (
                                    <div className="mt-3">
                                        <div className="small text-black-50">
                                            {data?.ourPriceShareExchangeSymbol}/CT{" "}
                                            {numberWithCommas(
                                                data?.ourRateShareExchange,
                                            )}
                                        </div>
                                        <div className="font-weight-bold font-size-h5">
                                            {data?.ourPriceShareExchangeSymbol}
                                            {numberWithCommas(
                                                data?.ourPriceShareExchange,
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col-12">
                            {!data?.showsharecertificate && 
                                <div className="small text-warning">
                                    Note: Certificate details will not be included in the shared link.
                                </div>
                            }
                            {!data?.showshareprice && 
                                <div className="small text-warning">
                                    Note: Price information will be hidden from the recipient.
                                </div>
                            }
                            {selectedValue === "mark_up"  &&
                                <div className="small text-warning">
                                    Note: Prices will be shared with markup applied (absolute / percentage as configured).
                                </div>
                            }
                        </div>
                    </>
                }
                <div className="col-12 d-flex justify-content-between align-items-center">
                        <span className="text-capitalize">share on {shareMode}</span>
                        <div className="d-flex">

                            <span
                                className={`share-social-icon ${shareMode === "email" ? "selected" : ""}`}
                                onClick={() => {
                                    setShareMode("email");
                                    setContactError("");
                                }}
                            >
                                <IoMailOutline size={18} />
                            </span>
                            <span
                                className={`share-social-icon ${shareMode === "whatsapp" ? "selected" : ""}`}
                                onClick={() => {
                                    setShareMode("whatsapp");
                                    setContactError("");
                                }}
                            >
                                <FaWhatsapp size={18} />
                            </span>
                        </div>
                </div>
                   <div className="col-12">
                        {shareMode === "email" ? (
                                <div className="input-group mb-2">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text bg-white border-right-0 pl-3 pr-0">
                                        {/* <BiUser className="text-muted" size={18} /> */}
                                                {contactType === "phone" ? (
                                                    <FaWhatsapp className="text-success" size={18} />
                                                ) : (
                                                    <IoMailOutline className="text-muted" size={18} />
                                                )}
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        value={contactInput}
                                        onChange={(e) => {
                                            setContactInput(e.target.value);
                                            setContactError("");
                                        }}
                                            className="form-control border-left-0"
                                        placeholder="Enter Email"
                                    />
                                </div>
                            ) : (
                                <div className="input-group mb-2 phone-bootstrap">
                                    {/* <div className="input-group-prepend">
                                        <span className="input-group-text bg-white border-right-0 pl-3 pr-0">
                                        <FaWhatsapp className="text-success" size={18} />
                                        </span>
                                    </div> */}

                                    <PhoneInput
                                        country={countryNameToIso(userinfo?.country)}
                                        value={contactInput}
                                        onChange={(phone) => {
                                            setContactInput(phone);
                                            setContactError("");
                                        }}
                                        inputClass="form-control"
                                        buttonClass="phone-flag-btn"
                                        containerClass="phone-container"
                                    />
                                </div>
                        )}
                        {contactError && (
                            <div className="text-danger text-left small mb-3">
                                {contactError}
                            </div>
                        )}
                   </div>
                <div className="col-12 text-center">
                    <div className={`onedrive-box ${focused ? "focused" : ""}`}>
                        <PiNotePencilLight
                            className="message-icon text-muted"
                            size={18}
                        />

                        <textarea
                            className="message-textarea"
                            placeholder="Add a message"
                            rows="3"
                            onChange={(e) => setNotes(e.target.value)}
                            onFocus={() => setFocused(true)}
                            onBlur={() => setFocused(false)}
                        />
                    </div>
                </div>
                <div className="col-12 mt-5 d-flex justify-content-between">
                    <div>
                        <button
                            className="btn btn-outline-secondary bg-primary-o-20 text-primary border-primary btn-sm mr-2"
                            onClick={() => {
                                setEditorData(generateDiamondText(data));
                                setContactInput('');
                                setOpenEditor(true);
                            }}
                        >
                            <PiFileTxt className="mr-2 font-size-h5" />
                            Text
                        </button>
                        <button
                            className="btn btn-outline-secondary bg-primary-o-20 text-primary border-primary btn-sm"
                            onClick={handleCopy}
                        >
                            <IoLinkOutline className="mr-2 font-size-h5" />
                            Copy link
                        </button>
                    </div>
                    <div>
                        <button
                            className={`btn btn-sm px-5 ${
                                shareMode === "whatsapp" ? "btn-primary" : "btn-primary"
                            }`}
                            onClick={handleSmartSend}
                            >
                            {shareMode === "whatsapp" ? (
                                <>
                                    <FaWhatsapp className="mr-2 font-size-h4" />
                                    Send via WhatsApp
                                </>
                            ) : (
                                <>
                                    <IoMailOutline className="mr-2 font-size-h4" />
                                    Send via Email
                                </>
                            )}
                            </button>
                    </div>
                </div>
                <div className="col-12 d-flex flex-column">
                    {startDate  ?
                        <div className="small text-warning">
                            Note: This link will expire on { startDate ? moment.tz(startDate, userinfo.timezone ? userinfo.timezone : Intl.DateTimeFormat().resolvedOptions().timeZone).format("YYYY-MM-DD") : "-"}.
                        </div>
                    : null}
                    {password  &&
                        <div className="small text-warning">
                            Note: Link is password protected.
                        </div>
                    }
                    {successMsg && (
                        <div className={`success-container ${successMsg ? "show" : ""} mb-3`}>
                            <div className="success-bar">
                                ✅ {successMsg}
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {openEditor && (
                <RichTextModal
                    open={openEditor}
                    countryNameToIso={countryNameToIso}
                    userinfo={userinfo}
                    contactInput={contactInput}
                    setContactInput={setContactInput}
                    setEditorValue={setEditorValue}
                    setContactError={setContactError}
                    contactError={contactError}
                    editorValue={editorValue}
                    setPhone={setPhone}
                    onClose={() => {setOpenEditor(false);setContactInput('')}}
                    initialValue={editorData}
                    title="Diamond Details"
                    setSuccessMsg={setSuccessMsg}
                    handleWhatsAppShare={handleWhatsAppShare}
                    onCopy={async (content) => {
                        const blob = new Blob([content], { type: "text/html" });
                        const data = [new ClipboardItem({ "text/html": blob })];

                        await navigator.clipboard.write(data);
                        setSuccessMsg('Text copied to clipboard!')
                        setOpenEditor(false);
                    }}
                />
            )}
        </>
    );
};

export default SharingComponent;
